import format from 'date-fns/format';
import { ru } from 'date-fns/locale';
import type {
    ITimeSlot,
    TDeliveryStatus,
    TDeliveryStatuses,
} from '@alfa-bank/site-dc-form-api/src/models';

import {
    REQUIRED_SERVICES,
    SERVICE_ALPHA_SMART,
    SERVICE_INDIVIDUAL_SALARY_CLIENT,
    THANK_PAGE_STATUSES,
} from './constants';

export const getTitleText = (pageType: TDeliveryStatus) => {
    switch (pageType) {
        case THANK_PAGE_STATUSES.COURIER_DELIVERY:
            return 'Доставка заказана';
        case THANK_PAGE_STATUSES.NAMED_OFFICE:
            return 'Пластиковая карта заказана';
        case THANK_PAGE_STATUSES.UNNAMED_OFFICE:
        case THANK_PAGE_STATUSES.ANY_OFFICE:
        default:
            return 'Пластиковая карта готова';
    }
};

// Форматируем объект с выбранным таймслотом в формат "1 августа с 15:00 до 17:00"
export const adaptDateTime = ({ deliveryDate, slotFrom, slotTo }: ITimeSlot) => {
    const date = format(new Date(deliveryDate), 'd MMMM', { locale: ru });

    return `${date} с ${slotFrom} до ${slotTo}`;
};

export const getTitleByStatus = (
    status: TDeliveryStatus,
    statusTitles: Record<TDeliveryStatuses, string>
) => {
    switch (status) {
        case 'COURIER_DELIVERY':
            return statusTitles.courierDelivery;
        case 'NAMED_OFFICE':
            return statusTitles.namedOffice;
        case 'UNNAMED_OFFICE':
            return statusTitles.unnamedOffice;
        case 'ANY_OFFICE':
            return statusTitles.anyOffice;
    }
};

/** Генерирует текст для информера на основе некарточных продуктов */
export const generateInformerText = (additionalServices: string[] | undefined): string => {
    const hasIndividualSalary = additionalServices?.includes(SERVICE_INDIVIDUAL_SALARY_CLIENT);
    const hasAlphaSmart = additionalServices?.includes(SERVICE_ALPHA_SMART);

    if (hasIndividualSalary && hasAlphaSmart) {
        return 'Напомните в офисе банка, что вы добавили подписку Альфа-Смарт и\u00A0Зарплатные привилегии к\u00A0вашей карте';
    } else if (hasIndividualSalary) {
        return 'Напомните в офисе банка, что вы добавили Зарплатные привилегии к\u00A0вашей карте';
    } else if (hasAlphaSmart) {
        return 'Напомните в офисе банка, что вы добавили подписку Альфа-Смарт к\u00A0вашей карте';
    }

    return '';
};

/** Проверяет, необходимо ли показывать информер пользователю  */
export const shouldShowInformer = (
    status: string,
    additionalServices: string[] | undefined
): boolean => {
    const isOffices = status !== THANK_PAGE_STATUSES.COURIER_DELIVERY;

    return isOffices && REQUIRED_SERVICES.some(service => additionalServices?.includes(service));
};
